import { AbstractSubmitStep } from "@component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FormLoanSimpleData } from "bm-ui-kit";
import { FormDecidable, FormLoanSimple, ProgressButton } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

interface StepFields {
	inKHR: boolean;
	existingLoans: FormLoanSimpleData[];
}

export class Step4 extends AbstractSubmitStep<StepFields> {
	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { submitState } = this.props;
		const disabled = this.isDisabled();

		return (
			<>
				<Card.Body>
					<FormLoanSimple
						label="Meglévő hitelek megadása"
						name="existingLoans"
						size="sm"
						disabled={disabled}
						required
					/>
					<FormDecidable
						label="Úgy szeretnék hitelt felvenni, hogy KHR (BAR) listán vagyok?"
						name="inKHR"
						disabled={disabled}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						type="submit"
						state={submitState}
						className={!form.getState().valid ? "disabled" : ""}
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
					>
						Kalkulálás
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step4";
	}
}
